import * as QUERIES from 'modules/billing-center/services/queries';
import { getMediaUrl } from 'components/getMedia';

interface ViewDocument {
  mediaId?: number;
  mediaVcode?: string;
  temporaryUrl?: string;
}

export function useDocuments() {
  const {
    mutateAsync: getAllDocuments,
    isLoading: getAllDocumentsLoading,
  } = QUERIES.useGetMatrixDocuments();

  const {
    mutateAsync: getPdfDocumentsByProposalId,
    isLoading: getPdfDocumentsByProposalIdLoading,
  } = QUERIES.useGetPdfDocumentsByProposalId({
    onError() {
      'Não foi possível carregar esse documento.';
    },
  });

  const {
    mutateAsync: deleteDocument,
    isLoading: deleteDocumentLoading,
  } = QUERIES.useDeleteDocument({
    onError() {
      'Não foi possível excluir esse documento.';
    },
    onSuccess() {
      'Documento excluído com sucesso!';
    },
  });

  const openImage = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank');
    link.style.display = 'none';
    document.body.appendChild(link);

    link.onload = () => {
      document.body.removeChild(link);
    };

    link.click();
  };

  async function handleViewDocuments({
    mediaId,
    mediaVcode,
    temporaryUrl,
  }: ViewDocument) {
    try {
      // Open immediately after upload
      if (temporaryUrl) {
        return openImage(temporaryUrl);
      }

      // Open only one image
      if (mediaId) {
        return openImage(
          getMediaUrl({ mediaId: mediaId, mediaVcode: mediaVcode })
        );
      }
    } catch (error) {
      return;
    }
  }

  const documentsLoading = getAllDocumentsLoading;

  return {
    documentsLoading,
    getAllDocuments,
    handleViewDocuments,
    getPdfDocumentsByProposalId,
    getPdfDocumentsByProposalIdLoading,
    deleteDocument,
    deleteDocumentLoading,
  };
}
